import { action } from "../common/Action"
import { CaldaieClient } from "../generated";

const service = new CaldaieClient();

class TipiCombustibileActions {
    @action
    async getAll() {
        return (await service.getTipiUsoCaldaia())!;

    };
}
export default new TipiCombustibileActions();